module.exports = __webpack_public_path__ + "static/media/Melk.baddf44c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Melk.jpg
// module id = 323
// module chunks = 0